import React from 'react'

const SvgHeartRateOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 20.994c-.438 0-.996-.369-.996-.369C5.77 16.992 2 13.81 2 8.995 2 5.627 4.42 3 7.5 3c1.74 0 3.41.883 4.5 2.267C13.09 3.883 14.76 3 16.5 3 19.58 3 22 5.627 22 8.995c0 4.815-3.803 7.997-9.003 11.63 0 0-.559.37-.997.37v-.001zm0-2.002c1.904-1.499 4.524-2.913 6.394-5.55l-1.034.005-1.986 1.363c-.238.156-.481.22-.732.19-.25-.03-.464-.16-.642-.392l-1.783-2.574-1.47 3.29c-.136.353-.371.57-.707.654-.335.084-.652-.012-.95-.288l-2.479-2.243h-.998C7.423 16.079 10 17.477 12 18.992zm7.424-7.54a5.602 5.602 0 00.578-2.457C20.002 7 18.602 5 16.502 5c-2.231 0-3.41 1.616-4.5 3-1.09-1.384-2.345-3-4.5-3-2.032 0-3.5 2.001-3.5 3.995 0 .73.218 1.567.589 2.457h2.406c.192.012.34.043.444.093.104.051.27.175.495.371l1.516 1.408 1.67-3.783c.195-.364.488-.546.88-.546s.693.182.904.546l2.183 3.047 1.08-.762c.232-.156.429-.257.59-.304.162-.046.402-.07.721-.07h1.944z'
    />
  </svg>
)

export default SvgHeartRateOutline
